import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'
import { MasterDataRow } from './MasterDataRow'
import type { KeyValue } from './masterData.types'

export function IdentifiersCard({ rows }: { rows: KeyValue[] }) {
  const { t } = useTranslation()
  return (
    <Card id={EID['masterdata-card-identifiers']}>
      <CardContent className="p-6">
        <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
          {t('productMasterData.cards.identifiers')}
        </h3>
        <dl>{rows.map((r) => <MasterDataRow key={r.label} row={r} />)}</dl>
      </CardContent>
    </Card>
  )
}
